module.exports = __webpack_public_path__ + "img/204.ef482de3.jpg";